"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editTags = exports.editTag = exports.getTags = exports.updateTagList = void 0;

var _apiServices = require("@pingum/api-services");

var types = _interopRequireWildcard(require("./types"));

var _networkDispatcher = require("../networkDispatcher");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var updateTagList = function updateTagList(tags) {
  return function (dispatch) {
    dispatch({
      type: types.TAG_SUCCESS,
      tagsHierarchy: tags
    });
  };
};

exports.updateTagList = updateTagList;

var getTags = function getTags(includeArchived, buildHierarchicalList) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TAG_REQUESTED,
      successType: types.TAG_SUCCESS,
      errorType: types.TAG_ERROR,
      promise: _apiServices.TagService.getTags(includeArchived, buildHierarchicalList),
      defaultErrorMessage: 'There was a problem loading all tags for the organization',
      responseName: buildHierarchicalList ? 'tagsHierarchy' : 'tags'
    });
  };
};

exports.getTags = getTags;

var editTag = function editTag(tagId, editTagRequest) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TAG_EDIT_REQUESTED,
      successType: types.TAG_EDIT_SUCCESS,
      errorType: types.TAG_EDIT_ERROR,
      promise: _apiServices.TagService.editTag(tagId, editTagRequest),
      successMessage: 'Successfully updated the tag',
      defaultErrorMessage: 'There was a problem editing this tag',
      responseName: 'updatedTag'
    });
  };
};

exports.editTag = editTag;

var editTags = function editTags(editTagsRequest) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.TAG_EDIT_REQUESTED,
      successType: types.TAGS_EDIT_SUCCESS,
      errorType: types.TAG_EDIT_ERROR,
      promise: _apiServices.TagService.editTags(editTagsRequest),
      successMessage: 'Successfully updated the tag',
      defaultErrorMessage: 'There was a problem editing the tags',
      responseName: 'updatedTags'
    });
  };
};

exports.editTags = editTags;